import './HowItWorks.css';

const HowItWorks = () => {
  return (
    <section className='howitworks container' id='how-it-works'>
      <h2 className='howitworks-header'>
        ¿Cómo <span className='lancaster-color'>funciona</span>?
      </h2>
      <div className='who-faq_component'>
        <div className='who-faq_item'>
          <div id='node-columns' className='faq_number-wrapper'>
            <div className='faq_number'>01</div>
          </div>
          <p className='text-size-medium'>
            <a
              href='https://wa.me/528112557887?text=Hola,%20quiero%20saber%20más%20sobre%20Lancaster'
              className='link'
              target='_blank'
              rel='noreferrer'
              alt='Contáctanos por Whatsapp'
            >
              <span className='lancaster-color'>Platícame de tu negocio por WhatsApp</span>
            </a>{' '}
            para discutir tus necesidades.
          </p>
        </div>
        <div className='who-faq_item'>
          <div id='node-columns' className='faq_number-wrapper'>
            <div className='faq_number'>02</div>
          </div>
          <p className='text-size-medium'>
            Creamos un asistente y configuramos el flujo de trabajo según las necesidades de tu operación.
          </p>
        </div>
        <div className='who-faq_item'>
          <div id='node-columns' className='faq_number-wrapper'>
            <div className='faq_number'>03</div>
          </div>
          <p className='text-size-medium'>
            Te mandamos llamadas de prueba.
          </p>
        </div>
        <div className='who-faq_item'>
          <div id='node-columns' className='faq_number-wrapper'>
            <div className='faq_number'>04</div>
          </div>
          <p className='text-size-medium'>
            Si te gusta lo que ves, te damos acceso al CRM: <span className='lancaster-color'>Lancaster</span>, donde puedes conectar Google Calendar para consultar disponibilidad y administrar citas.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
